import { useMiscellaneousData } from '../../contexts/ssr-miscellaneous-context';
import useFavicon from '../../hooks/useFavicon';
import { getOrganizationPropertiesByHost } from '../../utils/helpers';

function Favicon() {
  const { miscellaneousData } = useMiscellaneousData();
  const orgProperties = getOrganizationPropertiesByHost(miscellaneousData?.hostname);

  useFavicon(orgProperties?.favIcon);

  return null;
}
export default Favicon;
